var map = {
	"./image000001.png": 2502,
	"./image00001.jpeg": 206,
	"./image00003.jpeg": 2047,
	"./image00004.jpeg": 8738,
	"./image00005.jpeg": 6682,
	"./image00006.jpeg": 5577,
	"assets/fashionStyling/campaign/TODO-socks/image000001.png": 2502,
	"assets/fashionStyling/campaign/TODO-socks/image00001.jpeg": 206,
	"assets/fashionStyling/campaign/TODO-socks/image00003.jpeg": 2047,
	"assets/fashionStyling/campaign/TODO-socks/image00004.jpeg": 8738,
	"assets/fashionStyling/campaign/TODO-socks/image00005.jpeg": 6682,
	"assets/fashionStyling/campaign/TODO-socks/image00006.jpeg": 5577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8526;